import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_BEGIN,
  DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_FAILURE,
  DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function updateDeploymentSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = args.error ? Promise.reject(new Error()) : Promise.resolve();
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateDeploymentSettingError() {
  return {
    type: DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_BEGIN:
      return {
        ...state,
        updateDeploymentSettingPending: true,
        updateDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_SUCCESS:
      return {
        ...state,
        updateDeploymentSettingPending: false,
        updateDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_FAILURE:
      return {
        ...state,
        updateDeploymentSettingPending: false,
        updateDeploymentSettingError: action.data.error,
      };

    case DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_DISMISS_ERROR:
      return {
        ...state,
        updateDeploymentSettingError: null,
      };

    default:
      return state;
  }
}
